import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user';



@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private userSubject: BehaviorSubject<User | null>;
    public user: Observable<User | null>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!));
        this.user = this.userSubject.asObservable();
    }

    public get userValue() {
        return this.userSubject.value;
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authentication/login`, { username, password })
            .pipe(map(user => {
                // Almacena los detalles del usuario y el token jwt en el almacenamiento local para mantener al usuario conectado entre las actualizaciones de la página
                console.log(JSON.stringify(user)); //Mostramos el token en consola
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            }));
    }

    updatePassword(username: string, oldPassword: string, newPassword: string, confirmNewPassword: string) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authentication/update-password`, { username, oldPassword, newPassword, confirmNewPassword })
            .pipe(map(result => {
                return result;
            }));
    }
    updatePasswordRecover(username: string, newPassword: string, confirmNewPassword: string, token:string) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authentication/update-password-recover`, { username, newPassword, confirmNewPassword, token })
            .pipe(map(result => {
                return result;
            }));
    }

    resetPassword(userId: string, code: string, password: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}/api/Authentication/reset-password`, { userId, code, password });
    }

    validarExpiracionLink(fechaLink: string) {
        debugger;
        return this.http.get<any>(`${environment.apiUrl}/api/Authentication/validate-link/${fechaLink}`)
            .pipe(map(result => {
                return result;
            }));
    }


    forgetPassword(useremail: string, urlApp: string) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authentication/forget-password`, { useremail, urlApp })
            .pipe(map(result => {
                return result;
            }));
    }

    logout() {
        // elimina el usuario del almacenamiento local para cerrar la sesión del usuario
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.router.navigate(['/authentication/login']);
    }
}